export default __webpack_public_path__ + "static/Nox1-ce4953ad686f4a2a89a25f047fa586f5.png";